import { selectProjectState } from 'projectRedux/store';
import { eppDataAdapter } from '../adapters/eppDataAdapter';

export const {
  selectAll: selectAllEppDatas,
  selectById: selectEppDataBySupplyInside,
  selectEntities: selectEppDataEntities,
} = eppDataAdapter.getSelectors((state) => selectProjectState(state).eppdatas);
